import type { MenuProps } from 'antd';
import {
  MediaDeviceKind,
  type UseQuickVOResult,
} from '@/contexts/chat/scripts/hooks/useQuickVO/types';
import styles from './index.module.scss';

const SpeakerOperate = ({
  open,
  children,
  devicesData,
  getMediaDeviceKind,
  setMediaDeviceKind,
}: {
  open: boolean;
  children: ReactNode;
  devicesData: MediaDeviceInfo[];
  getMediaDeviceKind: UseQuickVOResult['getMediaDeviceKind'];
  setMediaDeviceKind: UseQuickVOResult['setMediaDeviceKind'];
}) => {
  const [activeKey, setActiveKey] = useState('');
  const [devices, setDevices] = useState<MenuProps['items']>([]);

  const defaultItems: MenuProps['items'] = useMemo(
    () => [
      {
        key: 'speaker',
        label: <div className={styles.menuLabel}>Speakers and headphones</div>,
        disabled: true,
      },
      {
        type: 'divider',
      },
    ],
    []
  );

  const getAudioOutputDevices = useCallback(
    async (devicesData: MediaDeviceInfo[]) => {
      if (
        activeKey &&
        open &&
        devicesData.find((device) => device.deviceId === activeKey)
      ) {
        await setMediaDeviceKind(MediaDeviceKind.AUDIO_OUTPUT, activeKey)?.catch(
          (_) => {
            message.warning('Device switching failed');
          }
        );
      }

      setDevices([
        ...defaultItems,
        ...devicesData!.map((device) => ({
          kind: device.kind,
          key: device.deviceId,
          label: <div className={styles.menuLabel}>{device.label}</div>,
        })),
      ]);
    },
    [activeKey, defaultItems, open, setMediaDeviceKind]
  );

  useEffect(() => {
    if (devicesData.length) {
      getAudioOutputDevices(devicesData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [devicesData.length]);

  useEffect(() => {
    if (open) {
      const deviceId = getMediaDeviceKind(MediaDeviceKind.AUDIO_OUTPUT);
      if (devicesData.find((device) => device.deviceId === deviceId)) {
        setActiveKey(deviceId!);
      } else {
        setMediaDeviceKind(MediaDeviceKind.AUDIO_OUTPUT, 'default');
        setActiveKey('default');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getMediaDeviceKind, open, setMediaDeviceKind]);

  return (
    <Dropdown
      overlayClassName={styles.dropdownwrapper}
      menu={{
        items: devices,
        activeKey,
        onClick: async (item) => {
          try {
            setActiveKey(item.key);
            await setMediaDeviceKind(MediaDeviceKind.AUDIO_OUTPUT, item.key);
          } catch (error) {
            message.warning('Device switching failed');
            console.log(error, 'error');
          }
        },
      }}
      placement="top"
      getPopupContainer={(e) => e.parentElement as HTMLDivElement}
    >
      <div>{children}</div>
    </Dropdown>
  );
};
export default SpeakerOperate;
